import './ShrinkHotspot.scss';

import { Hotspot, HotspotProps } from '@amzn/awsui-components-react';

const ShrinkHotspot = (props: HotspotProps): JSX.Element => {
    return Hotspot({...props, className:'shrinkHotspot'});
};

export default ShrinkHotspot;
